import { type Session } from '@ory/client-fetch';
import { Flex } from '@radix-ui/themes';
import { type QueryClient } from '@tanstack/react-query';
import { Outlet, createRootRouteWithContext, useLocation, useNavigate } from '@tanstack/react-router';
import React, { useEffect, type PropsWithChildren } from 'react';
import { useSession } from '~/features/auth/context/Session';
import { Services } from '~/services';
import { Organisation, OrganisationsPage } from '~/services/organisations-api/types';
// import { MaintenanceModal } from '~/components/MaintenanceModal';

type RouteContext = {
  queryClient: QueryClient;
  session: Session | null;
  organisation: Organisation | undefined;
  organisations: OrganisationsPage | undefined;
  services: Services;
};

const TanStackRouterDevtools =
  import.meta.env.MODE === 'production'
    ? () => null // Render nothing in production
    : React.lazy(() =>
        // Lazy load in development
        import('@tanstack/router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
        }))
      );

export const Route = createRootRouteWithContext<RouteContext>()({
  component: RootComponent,
  errorComponent: () => <div>Error</div>,
});

function Layout({ children }: PropsWithChildren) {
  return (
    <Flex minHeight="100%" direction="column">
      {children}
    </Flex>
  );
}

function RootComponent() {
  const { session } = useSession();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (session && location.pathname === '/') {
      navigate({ to: '/home' });
    }
  }, [session, location, navigate]);
  return (
    <>
      <Layout>
        <Outlet />
        {/* <MaintenanceModal title="System Maintenance" showModal={true} closeModal={() => {}} /> */}
      </Layout>
      {/* <TanStackRouterDevtools position="bottom-left" /> */}
    </>
  );
}
